export function SafetyCard({label,value,ok}:{label:string;value:string;ok:boolean}) {
  return <article className="safety-card"><i className={ok ? 'ok' : 'warn'}/><small>{label}</small><strong>{value}</strong></article>;
}
